import { CONFIG_UPDATE } from './types';
const initialState = {
    adultAges: {},
    i18n: {
        allowList: [],
        fallBacks: {
            default: ['en-US'],
        },
    },
    countries: [],
    documents: {
        privacypolicy: {},
        toupat: {},
    },
    documentsUrl: '',
    languages: [],
    partners: {},
    supportedCountries: [],
    validation: {
        identity: [],
        api: {
            patient: {
                firstName: {
                    stringMaxLength: 0,
                },
                lastName: {
                    stringMaxLength: 0,
                },
            },
        },
    },
    webviewsUrl: '',
    libreApiUrl: '',
    libreApiCountryUrls: {},
    libreSharingApiUrl: '',
    libreSharingApiCountryUrls: {},
    lvapiURL: '',
    lvApiCountryUrls: {},
    zipCodePatterns: {},
    regions: {},
};
export const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONFIG_UPDATE:
            return {
                ...state,
                ...action.config,
            };
        default:
            return state;
    }
};
